<template>
  <div class="attendance-list-container">
    <template v-if="isLoading">
      <div
        class="text-center"
        style="margin-top:100px;"
      >
        <img
          src="/img/aatt.svg"
          class="attendance-spinner"
          style="margin-bottom:40px"
        >
        <br style="clear:both">
        <span />
        {{ trans('core.loading') }}
      </div>
    </template>

    <template v-else>
      <div
        class="attendance-list-header"
        data-v-step="general"
      >
        <button
          v-if="!useOnSmartBoard"
          class="btn attendance-list-button"
          data-v-step="all_students"
          :disabled="disabledBySelectAll || allStudents.length === 0"
          @click="openSelectAllModal"
        >
          <span
            v-if="!allSelected"
            class="attendance-list-span"
          ><span class="fa fa-square-o" /> {{ trans('attendance_list.select_all') }}</span>
          <span
            v-else
            class="attendance-list-span"
          ><span class="fa fa-check-square-o" /> {{ trans('attendance_list.select_all') }}</span>
        </button>

        <div class="info-icon">
          <span
            v-tooltip.top-center="trans('attendance_list.colour_explanation')"
            class="fa fa-info-circle"
          />
        </div>

        <div
          class="click-save"
          :class="{ 'click-left':useOnSmartBoard }"
          data-v-step="save_time"
        >
          <span
            v-if="loadingClick"
            class="fa fa-spinner fa-pulse"
          />
          <template v-else-if="lastSaved !== ''">
            <span class="fa fa-check-circle-o visible-xs d-sm-none last-saved"> {{ lastSaved }}</span>
            <span class="hidden-xs d-none d-sm-block last-saved">{{ trans('attendance_list.last_saved_at') }} {{ lastSaved }}</span>
          </template>
        </div>

        <template v-if="!useOnSmartBoard">
          <div v-if="closeKeyAvailable && !confirmAvailable">
            <div
              v-if="closeKeyAvailable"
              class="btn pull-right attendance-list-button key-button"
              @click="openCloseKeyModal = true"
            >
              <span class="attendance-list-span">
                <span class="fa fa-key" /> {{ trans('attendance_list.close') }}
              </span>
            </div>
          </div>
          <div v-else-if="!closeKeyAvailable && confirmAvailable">
            <div
              v-if="confirmAvailable"
              class="btn pull-right confirm-attendances-button key-button"
              @click="openConfirmModal = true"
            >
              <span class="attendance-list-span hidden-xs">
                {{ trans('core.confirm_attendances') }}
              </span>
              <span class="attendance-list-span hidden-sm hidden-md hidden-lg">
                {{ trans('core.confirm') }}
              </span>
            </div>
          </div>
          <div
            v-else-if="closeKeyAvailable && confirmAvailable"
            class="dropdown"
          >
            <a
              class="btn attendance-list-button key-button"
              href="#"
              aria-hidden="true"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="true"
            >
              {{ trans('core.actions') }}  <span class="fa fa-caret-down" />
            </a>
            <ul class="dropdown-menu dropdown-menu-right">
              <li
                v-if="confirmAvailable"
                class="additional-contexts"
                @click="openConfirmModal = true"
              >
                {{ trans('core.confirm_attendances') }}
              </li>
              <li
                v-if="isLti && closeKeyAvailable"
                class="additional-contexts"
                @click="openCloseKeyModal = true"
              >
                {{ trans('attendance_list.key_close_title') }}
              </li>
            </ul>
          </div>
        </template>

        <div
          class="btn-group pull-right view-select-btn"
          role="group"
          data-v-step="photopage"
        >
          <button
            type="button"
            class="btn photo-button"
            :class="{ 'unselected-button': view === 'photo', 'attendance-list-button': view !== 'photo' }"
            @click="view = 'list'"
          >
            <span class="attendance-list-span fa fa-list" />
          </button>
          <button
            type="button"
            class="btn photo-button"
            :class="{ 'unselected-button': view === 'list', 'attendance-list-button': view !== 'list' }"
            @click="view = 'photo'"
          >
            <span class="attendance-list-span fa fa-user" />
          </button>
        </div>
      </div>

      <div
        class="attendance-list-content"
        data-v-step="row"
      >
        <template v-if="allStudents.length === 0">
          <span
            class="text-center"
            style="margin-top:20px; margin-left:10px;"
          >
            {{ trans('event.no_registration_or_no_scheduled') }}
          </span>
        </template>
        <template v-else>
          <template v-for="(student, index) in expectedStudents">
            <template v-if="view === 'list'">
              <attendance-list-row
                :use-on-smart-board="useOnSmartBoard"
                :course-id="courseId"
                :lesson-id="lessonId"
                :student-id="student.id"
                :disabled-by-select-all="disabledBySelectAll"
                :drop-class="expectedStudents.length > 5 && index > (expectedStudents.length - 5) ? 'dropup' : 'dropdown'"
                @attendanceRegistrationAttemptWhenDisabled="showAttendanceStartModal"
              />
            </template>
            <template v-else>
              <attendance-list-row-photo
                :key="index"
                :use-on-smart-board="useOnSmartBoard"
                :course-id="courseId"
                :lesson-id="lessonId"
                :student-id="student.id"
                :index="index"
                :drop-class="expectedStudents.length > 6 && index > (expectedStudents.length - 6) ? 'dropup' : 'dropdown'"
                :disabled-by-select-all="disabledBySelectAll"
                @attendanceRegistrationAttemptWhenDisabled="showAttendanceStartModal"
              >
                <template
                  v-if="isLti"
                  slot="photo"
                >
                  <photo-component
                    :student="student"
                  />
                </template>
              </attendance-list-row-photo>
            </template>
          </template>

          <div
            v-if="Object.values(unexpectedStudents).length > 0"
            class="row"
            style="height:3px; width:100%; background-color:#AAA; margin-left:0"
          />

          <template v-for="(student,index) in unexpectedStudents">
            <template v-if="view === 'list'">
              <attendance-list-row
                :key="index"
                :use-on-smart-board="useOnSmartBoard"
                :course-id="courseId"
                :lesson-id="lessonId"
                :student-id="student.id"
                :view="view"
                :disabled-by-select-all="disabledBySelectAll"
                @attendanceRegistrationAttemptWhenDisabled="showAttendanceStartModal"
              />
            </template>
            <template v-else>
              <attendance-list-row-photo
                :key="`${index}_unexpected`"
                :use-on-smart-board="useOnSmartBoard"
                :course-id="courseId"
                :lesson-id="lessonId"
                :student-id="student.id"
                :index="index"
                :disabled-by-select-all="disabledBySelectAll"
                @attendanceRegistrationAttemptWhenDisabled="showAttendanceStartModal"
              >
                <template
                  v-if="isLti"
                  slot="photo"
                >
                  <PhotoComponent
                    :student="student"
                  />
                </template>
              </attendance-list-row-photo>
            </template>
          </template>
        </template>

        <div style="flex-grow: 1" />
      </div>

      <div
        v-if="nrChangedAttendances > 0"
        class="attendance-exclamation"
        @click="echoAttendances"
      >
        <div style="color:#25167a">
          <div class="btn attendance-list-button">
            <span class="attendance-list-span">{{ trans('core.reload_page') }}</span>
          </div>
          {{ nrChangedAttendances > 1 ? trans('attendance_list.new_registrations', { number: nrChangedAttendances })
            : trans('attendance_list.new_registration', { number: nrChangedAttendances }) }}
        </div>
        <span
          class="fa fa-exclamation-triangle"
          style="color:#b71c1c; margin-left:5px;"
        />
      </div>

      <attendance-list-footer
        class="attendance-list-footer"
        :students-absent="studentsAbsent"
        :course-id="courseId"
        :lesson-id="lessonId"
        :students-attended="studentsAttended"
        :create-new-student="createNewStudent"
        @attendanceRegistrationAttemptWhenDisabled="showAttendanceStartModal"
        @startTour="$emit('startTour')"
      />

      <attendance-list-enable-modal
        v-if="openEnableAttendanceModal"
        :type="enableType"
        :attendance-data="enableAttendanceData"
        @closed-modal="openEnableAttendanceModal = false"
        @selectAll="selectAllStudents()"
      />

      <!--if there are 0 student attended during registration, ask if the registration will be continued now or later-->
      <!--important for attendanceregistererd state-->
      <modal
        :open="openNotRegisteredModal"
        :title="trans('attendance_list.register_later')"
        style="text-align:left; "
        :can-close-modal="false"
        backdrop="static"
        :keyboard="false"
      >
        <p>{{ trans('attendance_list.register_later_question') }}</p>
        <button
          type="button"
          class="btn btn-default pull-right"
          @click="changeRegisteredState"
        >
          {{ trans('attendance_list.register_later') }}
        </button>
        <button
          type="button"
          class="btn btn-success pull-right"
          @click="openNotRegisteredModal = false"
        >
          {{ trans('attendance_list.register_now') }}
        </button>
        <br style="clear:both">
      </modal>

      <!--Close key modal-->
      <modal
        v-if="closeKeyAvailable"
        :open="openCloseKeyModal"
        :title="trans('attendance_list.key_close_title')"
        style="text-align:left; "
        backdrop="static"
        @close="openCloseKeyModal = false"
      >
        <p>{{ trans('attendance_list.key_closed_verify') }}</p>
        <button
          type="button"
          class="btn btn-danger pull-right"
          @click="$emit('closeKey')"
        >
          {{ trans('attendance_list.key_close_title') }}
        </button>
        <button
          type="button"
          class="btn btn-cancel pull-right"
          @click="openCloseKeyModal = false"
        >
          {{ trans('core.cancel') }}
        </button>
        <br style="clear:both">
      </modal>

      <modal
        v-if="confirmAvailable"
        :open="openConfirmModal"
        :title="trans('core.confirm_attendances')"
        style="text-align:left; "
        backdrop="static"
        @close="openConfirmModal = false"
      >
        <p v-safe-html="trans('event.attendance_verified_question')" />
        <button
          type="button"
          class="btn btn-success pull-right"
          @click="$emit('confirmAttendances')"
        >
          {{ trans('core.confirm_attendances') }}
        </button>
        <button
          type="button"
          class="btn btn-cancel pull-right"
          @click="openConfirmModal = false"
        >
          {{ trans('core.cancel') }}
        </button>
        <br style="clear:both">
      </modal>

      <modal
        v-if="selectAllModal"
        :open="selectAllModal"
        :title="allSelected ? trans('attendance_list.mark_absent') : trans('attendance_list.mark_attended')"
        style="text-align:left; "
        backdrop="static"
        @close="selectAllModal = false"
      >
        <p v-safe-html="trans('attendance_list.select_all_explanation')" />
        <button
          type="button"
          class="btn btn-success pull-right"
          @click="selectAllStudents"
        >
          {{ allSelected ? trans('attendance_list.mark_absent') : trans('attendance_list.mark_attended') }}
        </button>
        <button
          type="button"
          class="btn btn-cancel pull-right"
          @click="selectAllModal = false"
        >
          {{ trans('core.cancel') }}
        </button>
        <br style="clear:both">
      </modal>
    </template>
  </div>
</template>

<script>

import AttendanceListRow from './AttendanceListRow.vue'
import AttendanceListRowPhoto from './AttendanceListRowPhoto.vue'
import AttendanceListFooter from './AttendanceListFooter.vue'
import AttendanceListEnableModal from './AttendanceListEnableModal'
import Modal from './Modal.vue'
import PhotoComponent from './PhotoComponent'
import Echo from 'laravel-echo'

export default {

  name: 'AttendanceListRaw',

  components: {
    AttendanceListEnableModal,
    AttendanceListRow,
    AttendanceListRowPhoto,
    AttendanceListFooter,
    PhotoComponent,
    Modal,
  },

  props: {
    courseId: {
      required: true,
      type: String,
    },
    lessonId: {
      required: true,
      type: String,
    },
    eventId: {
      required: true,
      type: String,
    },
    registrationEnabled: {
      default: false,
    },
    enableType: {
      default: 'single',
    },
    isLoading: {
      default: true,
    },
    disabledBySelectAll: {
      default: false,
    },
    isLti: {
      required: false,
      default: false,
    },
    closeKeyAvailable: {
      required: false,
      default: false,
    },
    confirmAvailable: {
      required: false,
      default: false,
    },
    useOnSmartBoard: {
      required: false,
      default: false,
    },
    createNewStudent: {
      required: false,
      default: true,
    },
  },

  data () {
    return {
      view: 'list',
      changedStudentIds: [],
      nrChangedAttendances: 0,
      enableAttendanceData: {},
      openEnableAttendanceModal: false,
      openNotRegisteredModal: false,
      openCloseKeyModal: false,
      openConfirmModal: false,
      selectAllModal: false,
    }
  },
  computed: {
    allStudents () {
      return Object.values(this.$store.state.attendancelist.students)
    },
    expectedStudents () {
      const students = this.allStudents.filter(student => student.attributes.expected)
      students.sort(function (a, b) {
        return ((a.attributes.sortName === b.attributes.sortName) ? 0 : ((a.attributes.sortName > b.attributes.sortName) ? 1 : -1))
      })
      return students
    },
    unexpectedStudents () {
      const students = this.allStudents.filter(student => !student.attributes.expected)

      students.sort((a, b) => {
        return ((a.attributes.sortName === b.attributes.sortName) ? 0 : ((a.attributes.sortName > b.attributes.sortName) ? 1 : -1))
      })
      return students
    },
    studentsAttended () {
      const studentIds = this.$store.state.attendancelist.attendances.studentIds
      return studentIds ? studentIds.length : null
    },
    studentsAbsent () {
      const studentIds = this.$store.state.attendancelist.attendances.studentIds
      if (studentIds) {
        const expectedStudentIds = this.expectedStudents.map(expectedStudent => expectedStudent.id)
        const filteredStudentIds = studentIds.filter((studentId) => expectedStudentIds.includes(studentId))
        return this.expectedStudents.length - filteredStudentIds.length
      }
      return null
    },
    attendedStudentIds () {
      return this.$store.state.attendancelist.attendances.studentIds
    },
    allSelected () {
      return this.studentsAttended === this.allStudents.length
    },
    loadingClick () {
      return this.$store.state.attendancelist.loadingClick
    },
    lastSaved () {
      return this.$store.state.attendancelist.lastSaved
    },
    attendanceListEnabled () {
      return this.$store.state.attendancelist.registrationAvailable
    },
  },

  watch: {
    studentsAttended (value, oldValue) {
      if (oldValue != null && value === 0) {
        this.openNotRegisteredModal = true
      }
    },

    isLoading (value) {
      if (value === false) {
        this.loaded()
      }
    },
  },

  methods: {
    loaded () {
      if (!this.isLti) {
        this.setupWebsocket()
      }
    },

    setupWebsocket () {
      this.echo = new Echo({
        broadcaster: 'pusher',
        key: document.head.querySelector('meta[name="pusher-key"]').content,
        wsHost: document.head.querySelector('meta[name="pusher-host"]').content,
        wsPort: document.head.querySelector('meta[name="pusher-port"]').content,
        encrypted: true,
        disableStats: true,
        enabledTransports: ['ws', 'wss'],
      })

      this.echo.private('event.' + this.eventId).listen('ChangedAttendance', (e) => {
        this.nrChangedAttendances = this.nrChangedAttendances + 1
        this.changedStudentIds.push(e.student_id)
      })
    },

    selectAllStudents () {
      if (!this.attendanceListEnabled) {
        this.showAttendanceStartModal({}, 'all')
        return
      }

      this.$emit('selectAllStudents', { allSelected: this.allSelected })
      this.selectAllModal = false
    },

    echoAttendances () {
      this.$emit('echoAttendances', { changedStudentIds: this.changedStudentIds })

      this.changedStudentIds = []
      this.nrChangedAttendances = 0
    },

    showAttendanceStartModal (event, type = 'single') {
      // Type ['all','single', 'new_student'] is if there is a single registration of all select all or new student
      this.enableAttendanceData = event
      this.enableType = type

      if (type === 'single' && (event === undefined || Object.keys(event).length === 0)) {
        this.enableType = 'new_student'
      }

      this.openEnableAttendanceModal = true
    },

    changeRegisteredState () {
      this.$emit('changedRegisteredState')
      this.openNotRegisteredModal = false
    },

    openSelectAllModal () {
      if (this.studentsAttended === 0) {
        this.selectAllStudents()
        return
      }

      this.selectAllModal = true
    },
  },
}
</script>

<style>
    .attendance-list-container {
        flex: 0 1 auto;
        display: flex;
        flex-direction: column;
        height: inherit;
    }

    .attendance-list-footer {
        display: flex;
        flex: 0 0 50px;
        flex-wrap: wrap;
        width: inherit;
        padding-right: 13px;
        padding-left: 13px;
        padding-top: 8px;
        background-color: #25167a;
        z-index: 999;
    }

    .attendance-exclamation {
        height: 60px;
        width: inherit;
        background-color: #EEEEEE;
        z-index: 999;
    }

    .awesome-checkbox .checkbox label {
        padding-left: 12px !important;
    }

    .awesome-checkbox .checkbox label::before {
        height: 25px !important;
        width: 25px !important;
    }

    .awesome-checkbox .checkbox label::after {
        height: 25px !important;
        width: 25px !important;
        font-size: 18px !important;
        padding-left: 4px !important;
    }

    .attendance-list-content {
        flex: 1 1 auto;
        overflow-x: hidden;
        overflow-y: auto;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start
    }

    .attendance-list-span {
        display: inline-block;
        vertical-align: middle;
        font-size: 13px;
        color: white;
    }

    .attendance-list-button {
        display: inline-block;
        background: #25167a !important;
        border: none;
        color: white !important;
        margin: 10px;
        padding: 10px 10px;
        text-align: center;
        flex: 0 0 auto;
    }

    .info-icon {
        font-size: 20px;
        color: #25167a !important;
        margin: auto;
        @media screen and (min-width: 767px) {
          margin-left: 10px;
        }

    }

    .tooltip-inner {
      max-width: 250px !important;
    }

    .confirm-attendances-button{
      display: inline-block;
      background: #22B14C !important;
      border: none;
      margin: 10px;
      padding: 10px 10px;
      text-align: center;
      flex: 0 0 auto;
      white-space: normal !important;
    }

    .photo-button {
        padding: 10px 17px !important;
    }

    .key-button {
        margin-right: 10px;
        margin-left: 0;
    }

    .additional-contexts {
        padding: 10px;
        color: black;
        cursor: pointer;
    }

    .additional-contexts a {
        color: black;
        text-decoration: none;
    }

    .dropdown-menu {
        min-width: 180px;
    }

    .dropdown-menu li:hover {
        background: #eee;
        text-decoration: none;
    }

    .attendance-list-header {
        display: flex;
        min-height: 60px;
        max-width: 99%;
    }

    .unselected-button {
      background: lightgray !important;
      margin: 0px;
    }

    .view-select-btn {
        margin-right: 10px;
        flex: 0 0 auto;
    }

    .click-save {
        flex: 1 1 auto;
        display: inline-block;
        text-align: center;
        padding-top: 10px;
        margin: 12px;
    }

    .click-left {
      text-align: left;
    }

    .last-saved {
        font-size: 12px;
        color: #25167a;
    }

    .attendance-spinner {
        width: 80px;
    }

</style>
